import React, { FC } from 'react';

import { IconProps } from '../../shared/ui';

export const MoveCross: FC<IconProps> = ({ width = 30, height = 30, fill = '#F7F7F7', className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="30" height="30" rx="6" />
      <path
        d="M14.25 6.5C14.25 6.09 14.59 5.75 15 5.75C15.41 5.75 15.75 6.09 15.75 6.5V23.5C15.75 23.91 15.41 24.25 15 24.25C14.59 24.25 14.25 23.91 14.25 23.5V6.5Z"
        fill={fill}
      />
      <path
        d="M6.5 15.75C6.09 15.75 5.75 15.41 5.75 15C5.75 14.59 6.09 14.25 6.5 14.25H23.5C23.91 14.25 24.25 14.59 24.25 15C24.25 15.41 23.91 15.75 23.5 15.75H6.5Z"
        fill={fill}
      />
      <path d="M15 4.75L18.25 8H11.75L15 4.75Z" fill={fill} />
      <path d="M15 25.25L11.75 22H18.25L15 25.25Z" fill={fill} />
      <path d="M4.75 15L8 11.75V18.25L4.75 15Z" fill={fill} />
      <path d="M25.25 15L22 18.25V11.75L25.25 15Z" fill={fill} />
    </svg>
  );
};
